"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var browser_1 = require("@cian/config/browser");
var shared_1 = require("@cian/peperrors/shared");
var shared_2 = require("@cian/system-logger/shared");
var Logger = /** @class */ (function () {
    function Logger(params) {
        this.transport = params.transport;
        this.errorFilter = params.errorFilter;
    }
    Logger.prototype.debug = function (message, meta) {
        if (process.env.NODE_ENV === 'development' || (0, browser_1.getConfig)().get('logger.browser.debug')) {
            this.transport.write((0, shared_2.createELKMessageLog)({ message: message, level: 'debug', meta: meta }));
        }
    };
    Logger.prototype.info = function (message, meta) {
        this.transport.write((0, shared_2.createELKMessageLog)({ message: message, level: 'info', meta: meta }));
    };
    Logger.prototype.warning = function (message, meta) {
        if (typeof message === 'string') {
            this.transport.write((0, shared_2.createELKMessageLog)({ message: message, level: 'warning', meta: meta }));
        }
        else {
            if (!this.errorFilter.approve(message)) {
                return;
            }
            this.transport.write((0, shared_2.createELKErrorLog)({ message: message, level: 'warning', meta: meta }));
        }
    };
    Logger.prototype.error = function (message, meta) {
        if (!this.errorFilter.approve(message)) {
            return;
        }
        var error = typeof message === 'string'
            ? new shared_1.UnknownError({
                message: message,
                domain: 'logger.error',
            })
            : message;
        var log = (0, shared_2.createELKErrorLog)({ message: error, level: 'error', meta: meta });
        this.transport.write(log);
    };
    return Logger;
}());
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map